import { render } from "./MailsEdit.vue?vue&type=template&id=6f48b3bf"
import script from "./MailsEdit.vue?vue&type=script&lang=js"
export * from "./MailsEdit.vue?vue&type=script&lang=js"

import "./MailsEdit.vue?vue&type=style&index=0&id=6f48b3bf&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__